import styled from 'styled-components';

import NumberFormat from 'react-number-format';
import { Input } from 'takeat-design-system-ui-kit';

export const Card = styled.div`
  background: #f6f6f6;
  border-radius: 10px;
  overflow: none;
`;

export const Map = styled.div`
  width: 100%;
  height: 600px;
  border-radius: 4px;

  .leaflet-control {
    z-index: 500;
  }
`;

export const SearchBtn = styled.button`
  height: 44px;
  width: 100%;
  min-width: 60px;
  border: none;
  background: #3bd2c1;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
`;

export const NumberInput = styled(NumberFormat)`
  height: 44px;
  width: 100%;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 4px;
  }
`;

export const CheckButton = styled.button`
  height: 40px;
  width: 40px;
  padding: 0 10px;
  border-radius: 8px;
  border: none;
  background-color: #0ccab4;
  svg {
    color: #fff;
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.lightGray};
    svg {
      filter: opacity(0.3);
      color: #333;
    }
  }
`;

export const TrashButton = styled.button`
  height: 44px;
  width: 22px;
  padding: 0 6px;
  border: none;
  background-color: #fff;
  svg {
    color: #f00;
  }
`;

export const InputStyled = styled(Input)`
  background-color: #fff;
  border-radius: 8px;
`;

export const TaxTitle = styled.h3`
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #222;
  margin-top: 16px;
`;

export const CurrencyWrapper = styled.div`
  input {
    border: 1px solid #545454;
  }
`;
